export const monitoring = {

  index: {
    title: 'Campaign monitoring'
  },

  operators: {
    topic: 'Operators',
    count_active: 'Сonversation',
    count_connected: 'Connected',
    state: {
      disconnected: 'Disconnected',
      connected: 'Сonversation'
    },
    disconnected: {
      state: 'Disconnected'
    },
    connected: {
      state: 'Connected'
    }
  },

  rooms: {
    topic: 'Rooms',
    empty: 'The room will disappear after',
    state: {
      ready: 'Ready',
      busy: 'Busy',
      pending: 'Operator disconnected',
      empty: 'Room is empty'
    }
  },

  tasks: {
    topic: 'Tasks',
    all: 'Total',
    pending: {
      state: 'Pending'
    },
    connected: {
      state: 'Pending operator'
    },
    dialing: {
      state: 'Dialing'
    },
    active: {
      state: 'Сonversation'
    },
    processing: {
      state: 'Processing'
    },
    checking: {
      state: 'Checking answerphone'
    },
    canceled: {
      state: 'Canceled'
    }
  },

  campaign: {
    topic: 'Campaign information',
    type: 'Type',
    avg_task: 'Average task duration'
  },

  field: {
    id: 'ID',
    number: 'Number',
    caller_id: 'Caller ID',
    priority: 'Priority',
    attempts: 'Attempts',
    strategy: 'Position in the strategy',
    start: 'Created at',
    status: 'Status',
    login: 'Login',
    avg_time: 'Average dial-up time',
    sec: 'sec',
    campaign: 'campaign',
    calc: 'ASR',
    drop: 'Reset ASR',
    last_attempt: 'Last attempt',
    next_attempt: 'Next attempt',
    created_at: 'Order created at',
    lead_date: 'Task created at'
  },
  
  state: {
    title: 'Status',
    success: 'Success',
    processing: 'Processing',
    canceled: 'Canceled',
    pending: 'Pending',
    fail: 'Fail'
  },

  button: {
    create: 'Monitoring'
  },

  type: {
    progressive: 'Progressive',
    predictive: 'Predictive'
  },

  modal: {
    create: 'Create task'
  }

}